import { render, staticRenderFns } from "./approvedTrans.vue?vue&type=template&id=1f4f8a9c&scoped=true"
import script from "./approvedTrans.vue?vue&type=script&lang=js"
export * from "./approvedTrans.vue?vue&type=script&lang=js"
import style0 from "./approvedTrans.vue?vue&type=style&index=0&id=1f4f8a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4f8a9c",
  null
  
)

export default component.exports